import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-72 h-72 bg-primary-100/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-accent-100/30 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
          {t('common:ctaTitle')}
        </h2>
        <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
          {t('common:ctaSubtitle')}
        </p>
        <div className="mt-7 md:mt-9">
          <Link
            to="/category/action"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('common:ctaButton')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}